import { FieldsToLookupByMasterAttributeId } from "global/Application";
import {
    IEntityReferenceValue as FAM_IEntityReferenceValue,
    IFlexibleFieldSet as FAM_IFlexibleFieldSet,
    IGroupConfigurationConfig as FAM_IGroupConfigurationConfig,
    IGroupConfigurationData as FAM_IGroupConfigurationData
} from "model/FlexibleAttributeModel";
import { Memoize } from "../Utility/TSFunctions";
import { BaseJsonTransformer, ITransformContext } from "./IJsonTransformer";
import { $oset_$data_feed_vendor_$abacus_id, $oset_$data_feed_vendor_$alegeus_id, $oset_$data_feed_vendor_$alight_id, $oset_$data_feed_vendor_$aon_hewitt_id, $oset_$data_feed_vendor_$artemis_health_inc_id, $oset_$data_feed_vendor_$bancorp_south_id, $oset_$data_feed_vendor_$bank_of_america_id, $oset_$data_feed_vendor_$benefit_recovery_id, $oset_$data_feed_vendor_$benefit_science_id, $oset_$data_feed_vendor_$benefitfocus_id, $oset_$data_feed_vendor_$blue_cross_and_blue_shield_of_kansas_city_id, $oset_$data_feed_vendor_$blue_cross_blue_shield_of_florida_id, $oset_$data_feed_vendor_$carefirst_id, $oset_$data_feed_vendor_$caremark_id, $oset_$data_feed_vendor_$catapult_health_id, $oset_$data_feed_vendor_$cci_health_id, $oset_$data_feed_vendor_$cerner_id, $oset_$data_feed_vendor_$conifer_id, $oset_$data_feed_vendor_$consumer_medical_id, $oset_$data_feed_vendor_$cotiviti_holdings_id, $oset_$data_feed_vendor_$deerwalk_id, $oset_$data_feed_vendor_$discovery_benefits_id, $oset_$data_feed_vendor_$esi_id, $oset_$data_feed_vendor_$evolution_1_id, $oset_$data_feed_vendor_$experian_id, $oset_$data_feed_vendor_$gallagher_id, $oset_$data_feed_vendor_$gilsbar_id, $oset_$data_feed_vendor_$grand_rounds_id, $oset_$data_feed_vendor_$hcdp_id, $oset_$data_feed_vendor_$hcms_id, $oset_$data_feed_vendor_$hcrm_id, $oset_$data_feed_vendor_$health_advocate_id, $oset_$data_feed_vendor_$health_endeavors_id, $oset_$data_feed_vendor_$health_equity_id, $oset_$data_feed_vendor_$healthcare_blue_book_id, $oset_$data_feed_vendor_$healthstat_id, $oset_$data_feed_vendor_$innovu_id, $oset_$data_feed_vendor_$kaig_id, $oset_$data_feed_vendor_$livongo_id, $oset_$data_feed_vendor_$lockton_id, $oset_$data_feed_vendor_$mcleod_pharmacy_id, $oset_$data_feed_vendor_$mycatalyst_id, $oset_$data_feed_vendor_$navigatormd_id, $oset_$data_feed_vendor_$optum_id, $oset_$data_feed_vendor_$paycom_id, $oset_$data_feed_vendor_$quantum_id, $oset_$data_feed_vendor_$scio_id, $oset_$data_feed_vendor_$scott_bob_hcsm_id, $oset_$data_feed_vendor_$seven_tablets_id, $oset_$data_feed_vendor_$triahealth_id, $oset_$data_feed_vendor_$truven_id, $oset_$data_feed_vendor_$vitality_id, $oset_$data_feed_vendor_$wageworks_id, $oset_$data_feed_vendor_$wellnecity_id, $oset_$data_feed_vendor_$yuma_id, $oset_$data_feed_vendor_$zero_card_id } from "model/ConfigOptionSetConstants";
import { $matt_$ancillary_$bcbs_attributeset_datafeed_id, $matt_$ancillary_$bcbs_datafeed1_vendor_lookup_id, $matt_$ancillary_$bcbs_vendorid_id } from "model/MasterAttributeConstants";

interface IMapping {

    [key: string]: {
        description: string;
        categories: {
            id: string;
            description: string;
        }[];
    };
}

interface ILookupMapping {
    [key: string]: {
        optionSetName: string;
        optionSetValue: number;
        carrierName: string;
        carrierId: string;
    }
}

/**
 * Transformers:
 * Moved from Sprint34Transformer.ts
 * optionset -> lookup for datafeed carrier option set to vendor lookup
 * https://dev.azure.com/blue-infosys/Group%20Library/_sprints/taskboard/Group%20Library%20Team/Group%20Library/Sprint%2034?workitem=531427
 */
export class Sprint34Transformer extends BaseJsonTransformer {
    config: FAM_IGroupConfigurationConfig;
    json: FAM_IGroupConfigurationData;

    addNotificationNIAMultiSelect: boolean = false;


    constructor({ config, json }: { config: FAM_IGroupConfigurationConfig, json: FAM_IGroupConfigurationData }) {
        super();
        this.config = config;

        this.json = json;

    }

    TransformerMapping() {

        const vendorIdMappings: ILookupMapping = {
            [$oset_$data_feed_vendor_$abacus_id]: {
                "optionSetName": "Abacus",
                "optionSetValue": 1,
                "carrierName": "Abacus",
                "carrierId": "1a5f621e-994e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$alegeus_id]: {
                "optionSetName": "Alegeus",
                "optionSetValue": 2,
                "carrierName": "Alegeus",
                "carrierId": "b48be375-994e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$alight_id]: {
                "optionSetName": "Alight",
                "optionSetValue": 3,
                "carrierName": "Alight",
                "carrierId": "5270d2fc-d79c-ed11-aad1-000d3a985797"
            },
            [$oset_$data_feed_vendor_$aon_hewitt_id]: {
                "optionSetName": "Aon Hewitt",
                "optionSetValue": 4,
                "carrierName": "Aon Hewitt",
                "carrierId": "a16186bf-994e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$artemis_health_inc_id]: {
                "optionSetName": "Artemis Health Inc.",
                "optionSetValue": 6,
                "carrierName": "Artemis Health Inc.",
                "carrierId": "3828e05f-9b4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$bancorp_south_id]: {
                "optionSetName": "Bancorp South",
                "optionSetValue": 7,
                "carrierName": "BancorpSouth | Cadence Bank",
                "carrierId": "38a326d4-9b4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$bank_of_america_id]: {
                "optionSetName": "Bank of America",
                "optionSetValue": 8,
                "carrierName": "Bank of America",
                "carrierId": "60432106-9c4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$benefit_recovery_id]: {
                "optionSetName": "Benefit Recovery",
                "optionSetValue": 9,
                "carrierName": "Benefit Recovery",
                "carrierId": "fd039468-9c4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$benefit_science_id]: {
                "optionSetName": "Benefit Science",
                "optionSetValue": 10,
                "carrierName": "Benefits Science LLC | MultiPlan",
                "carrierId": "72882cbe-9c4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$benefitfocus_id]: {
                "optionSetName": "BenefitFocus",
                "optionSetValue": 11,
                "carrierName": "BenefitFocus",
                "carrierId": "7a52dcc6-d89c-ed11-aad1-000d3a985797"
            },
            [$oset_$data_feed_vendor_$blue_cross_and_blue_shield_of_kansas_city_id]: {
                "optionSetName": "Blue Cross and Blue Shield of Kansas City",
                "optionSetValue": 12,
                "carrierName": "Blue Cross and Blue Shield of Kansas City",
                "carrierId": "d85d5c6a-9d4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$blue_cross_blue_shield_of_florida_id]: {
                "optionSetName": "Blue Cross Blue Shield of Florida",
                "optionSetValue": 13,
                "carrierName": "Blue Cross Blue Shield of Florida",
                "carrierId": "e4923f54-a04e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$carefirst_id]: {
                "optionSetName": "CareFirst",
                "optionSetValue": 14,
                "carrierName": "CareFirst",
                "carrierId": "abb6d6bf-f2de-ed11-a7c7-000d3a998404"
            },
            [$oset_$data_feed_vendor_$caremark_id]: {
                "optionSetName": "Caremark",
                "optionSetValue": 15,
                "carrierName": "CVS Caremark",
                "carrierId": "91802f3b-d39c-ed11-aad1-000d3a985797"
            },
            [$oset_$data_feed_vendor_$catapult_health_id]: {
                "optionSetName": "Catapult Health",
                "optionSetValue": 18,
                "carrierName": "Catapult",
                "carrierId": "1a56dd1f-ad71-ee11-9ae7-000d3a998139"
            },
            [$oset_$data_feed_vendor_$cci_health_id]: {
                "optionSetName": "CCI Health",
                "optionSetValue": 19,
                "carrierName": "CCI Health Services",
                "carrierId": "439d09f7-a04e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$cerner_id]: {
                "optionSetName": "Cerner",
                "optionSetValue": 20,
                "carrierName": "CernerWorks",
                "carrierId": "1a3b1919-a34e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$conifer_id]: {
                "optionSetName": "Conifer",
                "optionSetValue": 23,
                "carrierName": "Conifer Health Solutions",
                "carrierId": "c83c9ac3-a34e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$consumer_medical_id]: {
                "optionSetName": "Consumer Medical",
                "optionSetValue": 25,
                "carrierName": "Alight",
                "carrierId": "5270d2fc-d79c-ed11-aad1-000d3a985797"
            },
            [$oset_$data_feed_vendor_$cotiviti_holdings_id]: {
                "optionSetName": "Cotiviti Holdings",
                "optionSetValue": 26,
                "carrierName": "Cotiviti",
                "carrierId": "db07abc1-a44e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$deerwalk_id]: {
                "optionSetName": "Deerwalk",
                "optionSetValue": 27,
                "carrierName": "Cedar Gate Technologies | Deerwalk",
                "carrierId": "33197885-a64e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$discovery_benefits_id]: {
                "optionSetName": "Discovery Benefits",
                "optionSetValue": 28,
                "carrierName": "Discovery Benefits",
                "carrierId": "48ceb29c-1f9c-ed11-aad1-000d3a150860"
            },
            [$oset_$data_feed_vendor_$esi_id]: {
                "optionSetName": "ESI",
                "optionSetValue": 31,
                "carrierName": "ESI",
                "carrierId": "5eb7051f-119c-ed11-aad1-000d3a9851a0"
            },
            [$oset_$data_feed_vendor_$evolution_1_id]: {
                "optionSetName": "Evolution 1",
                "optionSetValue": 32,
                "carrierName": "Evolution Risk Partners",
                "carrierId": "04526ac8-7d93-ee11-be37-000d3a99809d"
            },
            [$oset_$data_feed_vendor_$experian_id]: {
                "optionSetName": "Experian",
                "optionSetValue": 34,
                "carrierName": "Experian",
                "carrierId": "4ef75b79-a94e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$gallagher_id]: {
                "optionSetName": "Gallagher",
                "optionSetValue": 35,
                "carrierName": "Gallagher",
                "carrierId": "f2ff91b6-a94e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$gilsbar_id]: {
                "optionSetName": "Gilsbar",
                "optionSetValue": 36,
                "carrierName": "Gilsbar",
                "carrierId": "fa520cf5-a94e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$grand_rounds_id]: {
                "optionSetName": "Grand Rounds",
                "optionSetValue": 37,
                "carrierName": "Included Health (fna Ground Rounds & Doctor On Demand",
                "carrierId": "a9bb20a0-aa4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$hcdp_id]: {
                "optionSetName": "HCDP",
                "optionSetValue": 39,
                "carrierName": "Health Care Data Partners",
                "carrierId": "ad24725d-0e51-ef11-a317-6045bded9012"
            },
            [$oset_$data_feed_vendor_$hcms_id]: {
                "optionSetName": "HCMS",
                "optionSetValue": 40,
                "carrierName": "Human Capital Management Solutions",
                "carrierId": "16f63a18-e554-ef11-a317-6045bda9ba6f"
            },
            [$oset_$data_feed_vendor_$hcrm_id]: {
                "optionSetName": "HCRM",
                "optionSetValue": 41,
                "carrierName": "Health Cost & Risk Management LLC",
                "carrierId": "333e3e6c-ab4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$health_advocate_id]: {
                "optionSetName": "Health Advocate",
                "optionSetValue": 42,
                "carrierName": "Health Advocate",
                "carrierId": "04ae6bd9-5bbd-ed11-83ff-000d3a99809d"
            },
            [$oset_$data_feed_vendor_$health_endeavors_id]: {
                "optionSetName": "Health Endeavors",
                "optionSetValue": 43,
                "carrierName": "Health Endeavors",
                "carrierId": "587320c2-ab4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$health_equity_id]: {
                "optionSetName": "Health Equity",
                "optionSetValue": 44,
                "carrierName": "Health Equity",
                "carrierId": "5465c28f-d79c-ed11-aad1-000d3a985797"
            },
            [$oset_$data_feed_vendor_$healthcare_blue_book_id]: {
                "optionSetName": "Healthcare Blue Book",
                "optionSetValue": 45,
                "carrierName": "Healthcare Bluebook",
                "carrierId": "70467e22-ac4e-ef11-a316-000d3a12a0c7"
            },
            [$oset_$data_feed_vendor_$healthstat_id]: {
                "optionSetName": "HealthStat",
                "optionSetValue": 47,
                "carrierName": "HealthStat, Inc. | Everside Health",
                "carrierId": "2ec96b04-af4e-ef11-a317-0022482fb1b8"
            },
            [$oset_$data_feed_vendor_$innovu_id]: {
                "optionSetName": "INNOVU",
                "optionSetValue": 50,
                "carrierName": "INNOVU",
                "carrierId": "800b4a58-0049-ee11-be6d-000d3a985348"
            },
            [$oset_$data_feed_vendor_$kaig_id]: {
                "optionSetName": "KAIG",
                "optionSetValue": 51,
                "carrierName": "Kelly & Associates Insurance Group",
                "carrierId": "a7a03ff6-0e51-ef11-a317-6045bded9012"
            },
            [$oset_$data_feed_vendor_$livongo_id]: {
                "optionSetName": "Livongo",
                "optionSetValue": 53,
                "carrierName": "Livongo",
                "carrierId": "fd9ddf2e-0f51-ef11-a317-6045bded9012"
            },
            [$oset_$data_feed_vendor_$lockton_id]: {
                "optionSetName": "Lockton",
                "optionSetValue": 54,
                "carrierName": "Lockton",
                "carrierId": "9fd59566-0f51-ef11-a317-6045bded9012"
            },
            [$oset_$data_feed_vendor_$mcleod_pharmacy_id]: {
                "optionSetName": "McLeod Pharmacy",
                "optionSetValue": 57,
                "carrierName": "McLeod Health | Pharmacy",
                "carrierId": "ecd3e657-1051-ef11-a317-6045bded9012"
            },
            [$oset_$data_feed_vendor_$mycatalyst_id]: {
                "optionSetName": "Mycatalyst",
                "optionSetValue": 61,
                "carrierName": "Veracity Benefits, LLC",
                "carrierId": "e6ce1f9c-6253-ef11-a317-6045bddabc19"
            },
            [$oset_$data_feed_vendor_$navigatormd_id]: {
                "optionSetName": "NavigatorMD",
                "optionSetValue": 62,
                "carrierName": "NavMD",
                "carrierId": "a7674913-6353-ef11-a317-6045bddabc19"
            },
            [$oset_$data_feed_vendor_$optum_id]: {
                "optionSetName": "Optum",
                "optionSetValue": 67,
                "carrierName": "Optum Health Behavioral Solution",
                "carrierId": "31ceb29c-1f9c-ed11-aad1-000d3a150860"
            },
            [$oset_$data_feed_vendor_$paycom_id]: {
                "optionSetName": "PayCom",
                "optionSetValue": 69,
                "carrierName": "PayCom",
                "carrierId": "52366ff9-d89c-ed11-aad0-000d3a9980e7"
            },
            [$oset_$data_feed_vendor_$quantum_id]: {
                "optionSetName": "Quantum",
                "optionSetValue": 75,
                "carrierName": "Quantum",
                "carrierId": "b8ceb29c-1f9c-ed11-aad1-000d3a150860"
            },
            [$oset_$data_feed_vendor_$scio_id]: {
                "optionSetName": "SCIO",
                "optionSetValue": 79,
                "carrierName": "EXL Service",
                "carrierId": "a87a4070-0254-ef11-a317-002248202aa8"
            },
            [$oset_$data_feed_vendor_$scott_bob_hcsm_id]:{
                "optionSetName": "Scott Bob - HCSM",
                "optionSetValue": 80,
                "carrierName": "Human Capital Management Solutions",
                "carrierId": "16f63a18-e554-ef11-a317-6045bda9ba6f"
            },
            [$oset_$data_feed_vendor_$seven_tablets_id]: {
                "optionSetName": "Seven Tablets",
                "optionSetValue": 81,
                "carrierName": "7t.co",
                "carrierId": "127a75e4-d154-ef11-a317-00224826e56f"
            },
            [$oset_$data_feed_vendor_$triahealth_id]: {
                "optionSetName": "TriaHealth",
                "optionSetValue": 83,
                "carrierName": "Tria Health",
                "carrierId": "82379f08-d254-ef11-a317-00224826e56f"
            },
            [$oset_$data_feed_vendor_$truven_id]: {
                "optionSetName": "Truven",
                "optionSetValue": 84,
                "carrierName": "Truven",
                "carrierId": "4a01d14b-d254-ef11-a317-00224826e56f"
            },
            [$oset_$data_feed_vendor_$vitality_id]: {
                "optionSetName": "Vitality",
                "optionSetValue": 89,
                "carrierName": "Vitality",
                "carrierId": "076ba374-f454-ef11-a317-7c1e5218518d"
            },
            [$oset_$data_feed_vendor_$wageworks_id]: {
                "optionSetName": "WageWorks",
                "optionSetValue": 91,
                "carrierName": "WageWorks",
                "carrierId": "ef2e6aaa-d49c-ed11-aad0-000d3a9980e7"
            },
            [$oset_$data_feed_vendor_$wellnecity_id]: {
                "optionSetName": "Wellnecity",
                "optionSetValue": 92,
                "carrierName": "Wellnecity",
                "carrierId": "d57e0cc5-f454-ef11-a317-7c1e5218518d"
            },
            [$oset_$data_feed_vendor_$yuma_id]: {
                "optionSetName": "Yuma",
                "optionSetValue": 96,
                "carrierName": "Yuma Regional Medical Center",
                "carrierId": "85e9cc34-f554-ef11-a317-7c1e5218518d"
            },
            [$oset_$data_feed_vendor_$zero_card_id]: {
                "optionSetName": "Zero Card",
                "optionSetValue": 97,
                "carrierName": "Zero Card",
                "carrierId": "a4b1687f-f554-ef11-a317-7c1e5218518d"
            }

        };

        return {
            vendorIdMappings
        }
    }

    async before(json: FAM_IGroupConfigurationData): Promise<void> {

    }

    async transformAttributeSet(attributeSet: FAM_IFlexibleFieldSet, context: ITransformContext): Promise<boolean | void> {
        //data feed attribute set: https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_attribute&id=4ed7c5a7-d590-ec11-b400-0022480a93ed
        if (attributeSet.attributeSetRef.id === $matt_$ancillary_$bcbs_attributeset_datafeed_id) {

            const fieldInfosMemoized = Memoize(() => {
                return FieldsToLookupByMasterAttributeId(this.config, attributeSet.fields);
            });

            const fieldsByMasterAttrId = fieldInfosMemoized();

            //option set -> carrier lookup transformer 
            //carriers - optionSet (original)
            //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=818b0bc2-a215-ed11-b83c-00224820a835&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=1998f1ab-3d58-ec11-8f8f-000d3a597a8a
            const bcbs_vendor_masterAttribute_old = fieldsByMasterAttrId[$matt_$ancillary_$bcbs_vendorid_id]

            if (bcbs_vendor_masterAttribute_old) {
                const bcbs_vendor_old = bcbs_vendor_masterAttribute_old[0];

                //if old field exists get the value id from it
                const valueVendorOldId = bcbs_vendor_old.field.values[0].value?.type === "entity" ? bcbs_vendor_old.field.values[0].value.id : "";

                //Vendor - Lookup
                //https://bcbsonlinesys.crm.dynamics.com/main.aspx?appid=be2013bc-a215-ed11-b83c-00224820a835&forceUCI=1&pagetype=entityrecord&etn=bcbs_config_masterattribute&id=b5a81611-0951-ef11-a317-7c1e5218b3c4
                const bcbs_vendorLookup_masterAttribute = fieldsByMasterAttrId[$matt_$ancillary_$bcbs_datafeed1_vendor_lookup_id];
                if (bcbs_vendorLookup_masterAttribute) {
                    const bcbs_vendorLookup = bcbs_vendorLookup_masterAttribute[0];
                    const value_bcbs_vendor_new = bcbs_vendorLookup.field.values[0];

                    if (valueVendorOldId && !value_bcbs_vendor_new.value) {
                        var vendorLookupValue = this.TransformerMapping().vendorIdMappings[valueVendorOldId];

                        if (vendorLookupValue) {
                            var newLookupValue: FAM_IEntityReferenceValue = {
                                type: "entity",
                                entityType: "bcbs_carrier",
                                id: vendorLookupValue.carrierId,
                                name: vendorLookupValue.carrierName,
                            };
                            bcbs_vendorLookup.field.values[0].value = newLookupValue;
                        }
                    }
                }

            }
        }
    }

    async after(json: FAM_IGroupConfigurationData): Promise<void> {

        console.debug("[tran] Sprint34Transformer.after")

        if (!json.transformers)
            json.transformers = {};

        json.transformers.Sprint34 = true

    }
}
